import { LOGIN_SAFE_REDIRECT } from './constants';
import { getUnleashClient } from './unleashClient';

/**
 * Returns true only when the `login.safeRedirect` Unleash flag is explicitly
 * enabled for the current client. Used at login-flow redirect sites to gate
 * the staged rollout of the DEV-20732 CWE-601 open-redirect sanitisation:
 * at 0% rollout each site uses its pre-DEV-20732 legacy behaviour (which
 * may transform inputs in site-specific ways — e.g. LoginGuard applies
 * `extractUrlPath` to `redirectTo`, SAML sites prepend `window.location.origin`
 * — but does not sanitise cross-origin or non-http(s) inputs); as the flag
 * rolls toward 100% the sanitised path (`safeRedirectPath` / `safeRedirectURL`)
 * takes over for that share of users.
 *
 * Returns false on any error (no client yet, proxy unreachable, etc.) so
 * the rollout cohort is well-defined: clients only get the safe path when
 * the proxy explicitly confirms membership. There is a brief per-render
 * window between page load and proxy response during which the legacy
 * behaviour is used; accepted trade-off for the rollout pattern.
 *
 * Security-critical: see DEV-20732 (CWE-601 open-redirect hardening).
 */
export const isSafeRedirectEnabled = (): boolean => {
  try {
    return getUnleashClient().isEnabled(LOGIN_SAFE_REDIRECT);
  } catch {
    return false;
  }
};
